import { render, staticRenderFns } from "./ConfigReviews.vue?vue&type=template&id=45336c80&"
import script from "./ConfigReviews.vue?vue&type=script&lang=js&"
export * from "./ConfigReviews.vue?vue&type=script&lang=js&"
import style0 from "./ConfigReviews.vue?vue&type=style&index=0&id=45336c80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports